import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#050811] text-[#F8F5EE] flex flex-col items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center border border-[#C1A661]/25 rounded-sm p-10 bg-[#080C17]">
        <XCircle size={52} strokeWidth={1.2} className="text-[#E86B8C] mx-auto" />
        <h1 className="mt-5 font-serif text-3xl font-light text-[#E2CFA4]">{t.cancel.title}</h1>
        <p className="mt-3 text-sm text-[#A1A7B3] font-light">{t.cancel.body}</p>
        <button
          data-testid="cancel-home-btn"
          onClick={() => navigate("/")}
          className="mt-8 w-full py-3 rounded-sm border border-[#C1A661]/40 hover:border-[#C1A661] text-[11px] tracking-[0.25em] uppercase text-[#E2CFA4] hover:text-[#F8F5EE] transition-colors"
        >
          {t.cancel.cta}
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;
